import { Component, Input } from '@angular/core';

@Component({
  selector: 'top-banner, page-top-banner',
  templateUrl: './top-banner.component.html',
})
export class TopBannerComponent {
  @Input() variant: 'small' | 'logo' | 'title' | 'custom' = 'small';
  @Input() title: string = '';
}
